import { Button, Col, Row } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  creationMap,
  creationRolesDelimiter,
  creditsRoles,
  URLS,
} from "../../utils-creation/constants";
import { Creation, CreationRole } from "../../utils-creation/types";
import { sortByCreationRoles } from "../../utils-creation/utils";
import ParagraphWithNewlines from "./ParagraphWithNewlines";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../utils/types";
import {
  deleteCreation,
  getCreationYearsStats,
  initList,
  resetState,
} from "../../features/content/setting_page/CreationPanel/creationPanelSlice";
import "./Creation.css";
import ConfirmDeleteCreationModal from "./ConfirmDeleteCreationModal";

interface Props {
  creation: Creation;
  isSettingsPage?: boolean;
}

export default function CreationDescription({
  creation,
  isSettingsPage,
}: Props) {
  const [ellipsisExpanded, setEllipsisExpanded] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.authentication);

  const {
    yearFilter: { year: selectedYear },
  } = useSelector((state: RootState) => state.creationPanel);

  let _duration_minutes: number | string = 0;
  let _duration_seconds: number | string = 0;
  if (creation["duration_in_seconds"] && creation["duration_in_seconds"] > 0) {
    _duration_minutes = Math.floor(creation["duration_in_seconds"] / 60);
    _duration_seconds = creation["duration_in_seconds"] % 60;
    if (_duration_seconds < 10) {
      _duration_seconds = `0${_duration_seconds}`;
    }
  }

  const description = (
    <div className="creation-description">
      <p>
        {/* Media */}
        {creation.media}

        {/* Duration */}
        {/* Note: 0 && <span>test</span> renders 0 */}
        {!!creation.duration_in_seconds && (
          <span>
            . {_duration_minutes}:{_duration_seconds} minutes
          </span>
        )}
      </p>

      {/* Premiere */}
      <p>
        <strong>{creationMap.premiere_venue.toUpperCase()}:</strong>

        <span> {creation.premiere_venue}</span>

        {creation.premiere_venue_type && (
          <span>, {creation.premiere_venue_type}</span>
        )}

        <span>, {creation.premiere_city_country}</span>

        <span>, {creation.premiere_year}</span>
      </p>

      {/* Non-Premiere 1 */}
      {creation.non_premiere_1_venue && (
        <p>
          <strong>SELECTED PRESENTATIONS:</strong>
          <span> {creation.non_premiere_1_venue}</span>

          {creation.non_premiere_1_venue_type && (
            <span>, {creation.non_premiere_1_venue_type}</span>
          )}

          {creation.non_premiere_1_city_country && (
            <span>, {creation.non_premiere_1_city_country}</span>
          )}

          {creation.non_premiere_1_year && (
            <span>, {creation.non_premiere_1_year}</span>
          )}
        </p>
      )}

      {/* Non-Premiere 2 */}
      {creation.non_premiere_2_venue && (
        <p>
          <span style={{ marginLeft: 169 }}>
            {creation.non_premiere_2_venue}
          </span>

          {creation.non_premiere_2_venue_type && (
            <span>, {creation.non_premiere_2_venue_type}</span>
          )}

          {creation.non_premiere_2_city_country && (
            <span>, {creation.non_premiere_2_city_country}</span>
          )}

          {creation.non_premiere_2_year && (
            <span>, {creation.non_premiere_2_year}</span>
          )}
        </p>
      )}

      {/* Researchers */}
      {creation.researchers_list && creation.researchers_list.length > 0 && (
        <p>
          <strong>{creationMap.researchers_list.toUpperCase()}:</strong>
          {creation.researchers_list
            .map((researcher) => {
              return {
                ...researcher,
                roles: (
                  ((researcher.roles as string)?.split(
                    creationRolesDelimiter
                  ) as CreationRole[]) ?? []
                ).sort(sortByCreationRoles),
              };
            })
            .sort((r1, r2) => {
              const a = r1.roles && r1.roles.length > 0 ? r1.roles[0] : "";
              const b = r2.roles && r2.roles.length > 0 ? r2.roles[0] : "";
              return sortByCreationRoles(a as CreationRole, b as CreationRole);
            })
            .map((researcher) => {
              return (
                <span key={researcher.random_id}>
                  {" "}
                  <u>
                    <Link to={`/profile/${researcher.random_id}`}>
                      {researcher.preferred_first_name}{" "}
                      {researcher.preferred_last_name}
                    </Link>
                  </u>{" "}
                  ({(researcher.roles as string[]).join(", ")})
                </span>
              );
            })}
        </p>
      )}

      {/* Description */}
      {!ellipsisExpanded && (
        <>
          <p>
            <strong>{creationMap.description.toUpperCase()}:</strong>
            <span>
              {" "}
              {creation.description.length < 199
                ? creation.description
                : creation.description.substring(0, 200)}
              ...
            </span>
          </p>
          <Button
            type="link"
            onClick={() => setEllipsisExpanded(true)}
            style={{
              height: 22,
              padding: 0,
              borderRadius: 0,
              borderWidth: 0,
            }}
          >
            show more
          </Button>
        </>
      )}

      {ellipsisExpanded && (
        <>
          <br />
          <p>
            <strong>{creationMap.description.toUpperCase()}:</strong>
          </p>
          <ParagraphWithNewlines paragraph={creation.description} />

          {/* Credits */}
          <br />
          <p>
            <strong>CREDITS:</strong>
          </p>

          {creditsRoles
            .filter((role) => creation[role])
            .map((role) => (
              <p key={creationMap[role]}>
                {creationMap[role]}: {creation[role]}
              </p>
            ))}

          {/* Additional Credits */}
          {creation.additional_credits && (
            <>
              <br />
              <p>
                <strong>{creationMap.additional_credits.toUpperCase()}:</strong>
              </p>

              <ParagraphWithNewlines paragraph={creation.additional_credits} />
            </>
          )}

          <Button
            type="link"
            onClick={() => setEllipsisExpanded(false)}
            style={{
              height: 22,
              // marginLeft: 4,
              padding: 0,
              borderRadius: 0,
              borderWidth: 0,
            }}
          >
            show less
          </Button>
        </>
      )}
      <br />
    </div>
  );

  if (!isSettingsPage) return description;

  return (
    <Row justify="space-between" align="top">
      <Col xs={24} sm={24} md={19} lg={19}>
        {description}
      </Col>
      <Col xs={24} sm={24} md={5} lg={5} className="sub-heading-font">
        <Link to={`${URLS.RESEARCH_CREATION_EDIT}/${creation.id}`}>
          <Button style={{ marginRight: "1rem" }}>EDIT</Button>
        </Link>
        <ConfirmDeleteCreationModal
          title={creation.title}
          onConfirm={() =>
            dispatch(
              deleteCreation({
                payload: creation.id,
                callback: () => {
                  dispatch(resetState());
                  user && dispatch(getCreationYearsStats(user.random_id));
                  user &&
                    dispatch(
                      initList({ randomID: user.random_id, year: selectedYear })
                    );
                },
              })
            )
          }
        />
      </Col>
    </Row>
  );
}
